import Vue from 'vue';
import Router from 'vue-router';
import AccountService from '@/services/account';
import ResourceManager from '@/services/resource.service';

import {
  Account,
  SubscriptionInformation,
  Integrations,
} from '@/router/account.router';
import store from '@/store/store';

import {
  InterviewList,
  InterviewAdd,
  InterviewEdit,
  InterviewDetail,
  CandidateDetail,
  InterviewSend,
  UserList,
  PricingList,
  GeneralConditions,
  QuestionGeneratorAdd,
  QuestionGeneratorEdit,
  QuestionGeneratorList,
  ContactUs,
  FaqList,
  // BlogList,
  // BlogDetail,
} from './hrVenue.router';

const MainNavbar = (resolve) => {
  require.ensure(['@/components/layout/MainNavbar'], () => {
    resolve(require('@/components/layout/MainNavbar'));
  });
};

const MainSidebarMenu = (resolve) => {
  require.ensure(['@/components/layout/MainSidebarMenu'], () => {
    resolve(require('@/components/layout/MainSidebarMenu'));
  });
};

const App = (resolve) => {
  require.ensure(['@/App'], () => {
    resolve(require('@/App'));
  });
};

const HomeView = (resolve) => {
  require.ensure(['@/components/Home'], () => {
    resolve(require('@/components/Home'));
  });
};

const DesignKitView = (resolve) => {
  require.ensure(['@/components/DesignKit'], () => {
    resolve(require('@/components/DesignKit'));
  });
};

const LoginView = (resolve) => {
  require.ensure(['@/components/account/LoginPage'], () => {
    resolve(require('@/components/account/LoginPage'));
  });
};

const RegisterView = (resolve) => {
  require.ensure(['@/components/account/RegisterPage'], () => {
    resolve(require('@/components/account/RegisterPage'));
  });
};

const ForgotPassView = (resolve) => {
  require.ensure(['@/components/account/ForgotPassword'], () => {
    resolve(require('@/components/account/ForgotPassword'));
  });
};

const ResetPasswordView = (resolve) => {
  require.ensure(['@/components/account/ResetPassword'], () => {
    resolve(require('@/components/account/ResetPassword'));
  });
};

const PageNotFoundView = (resolve) => {
  require.ensure(['@/components/misc/PageNotFound'], () => {
    resolve(require('@/components/misc/PageNotFound'));
  });
};

const UnifiedCallback = (resolve) => {
  require.ensure(['@/components/unified/UnifiedCallback'], () => {
    resolve(require('@/components/unified/UnifiedCallback'));
  });
};

const supportedLanguages = ['tr', 'en', 'de', 'fr', 'es'];
const defaultLanguage = 'en';
const localeMap = {
  tr: 'tr-TR',
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
};
const defaultLocale = localeMap[defaultLanguage];

const routes = [
  {
    path: '/:lang(tr|de|fr|es|en)?',
    components: {
      default: App,
    },
    children: [
      {
        path: '',
        name: 'HomeView',
        components: {
          top: MainNavbar,
          sidebar: MainSidebarMenu,
          content: HomeView,
        },
        meta: {
          className: 'home-page',
          requiresAuth: false,
          title: 'Ana Sayfa',
          resource: 'home.PageTitle',
        },
        beforeEnter(to, from, next) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            page_type: 'home/dashboard',
            site_type: 'interview',
          });
          next();
        },
      },
      InterviewList(MainNavbar, MainSidebarMenu),
      InterviewAdd(MainNavbar, MainSidebarMenu),
      UserList(MainNavbar, MainSidebarMenu),
      InterviewEdit(MainNavbar, MainSidebarMenu),
      InterviewDetail(MainNavbar, MainSidebarMenu),
      CandidateDetail(MainNavbar, MainSidebarMenu),
      InterviewSend(MainNavbar, MainSidebarMenu),
      PricingList(null, MainSidebarMenu),
      GeneralConditions(null, null),
      QuestionGeneratorList(MainNavbar, MainSidebarMenu),
      QuestionGeneratorAdd(MainNavbar, MainSidebarMenu),
      QuestionGeneratorEdit(MainNavbar, MainSidebarMenu),
      FaqList(MainNavbar, MainSidebarMenu),

      Account(MainNavbar, MainSidebarMenu),
      SubscriptionInformation(MainNavbar, MainSidebarMenu),
      Integrations(MainNavbar, MainSidebarMenu),
      ContactUs(null, null),
      {
        path: 'login',
        name: 'LoginView',
        components: {
          content: LoginView,
        },
        meta: {
          className: 'page-login',
          requiresAuth: false,
          title: 'Giriş',
          resource: 'login.PageTitle',
        },
        beforeEnter(to, from, next) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            page_type: 'login',
            site_type: 'interview',
          });
          next();
        },
      },
      {
        path: 'register',
        name: 'RegisterView',
        components: {
          content: RegisterView,
        },
        meta: {
          className: 'page-register',
          requiresAuth: false,
          title: 'Kayıt',
          resource: 'register.PageTitle',
        },
        beforeEnter(to, from, next) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            page_type: 'register',
            site_type: 'interview',
          });
          next();
        },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassView',
        components: {
          content: ForgotPassView,
        },
        meta: {
          className: 'page-login',
          requiresAuth: false,
          title: 'Şifremi Unuttum',
          resource: 'forgotPassword.PageTitle',
        },
      },
      {
        path: 'reset-password/:id/:uuid?',
        name: 'ResetPasswordView',
        components: {
          content: ResetPasswordView,
        },
        meta: {
          className: 'page-login',
          requiresAuth: false,
          title: 'Sifremi Yenile',
        },
      },
      {
        path: 'unified-callback',
        name: 'UnifiedCallback',
        components: {
          content: UnifiedCallback,
        },
        meta: {
          requiresAuth: true,
          title: 'Unified Callback',
        },
      },
      {
        path: 'design-kit',
        name: 'DesignKitView',
        components: {
          content: DesignKitView,
        },
        meta: {
          showProgressBar: false,
          className: 'design-kit',
          requiresAuth: false,
          title: 'DesignKit',
        },
      },
      {
        path: '*',
        name: 'PageNotFoundView',
        components: {
          top: MainNavbar,
          sidebar: MainSidebarMenu,
          content: PageNotFoundView,
        },
        meta: {
          className: 'page-page-not-found',
          requiresAuth: true,
          title: 'Sayfa bulunamadı',
          resource: 'notFound.PageTitle',
        },
      },
    ],
  },
  {
    path: '*',
    name: 'PageNotFoundView',
    components: {
      top: MainNavbar,
      sidebar: MainSidebarMenu,
      content: PageNotFoundView,
    },
    meta: {
      className: 'page-page-not-found',
      requiresAuth: true,
      title: 'Sayfa bulunamadı',
      resource: 'notFound.PageTitle',
    },
  },
];

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
});
/*
['push', 'replace'].forEach((method) => {
  const originalMethod = Router.prototype[method];
  Router.prototype[method] = function m (location) {
    return originalMethod.call(this, location).catch((error) => {
      if (error.name !== 'NavigationDuplicated') {
        throw error;
      }
    });
  };
});
*/

router.afterEach((to) => {
  // param değişikliği var ise burada olmalı GTM
  window.dataLayer = window.dataLayer || [];
  if (to.name === 'HrVenueView') {
    dataLayer.push({
      page_type: 'interview-listing',
      site_type: 'interview',
      // tab_name: to.params.tabName === 'actives' ? 'published' : 'passives',
    });
  } else if (to.name === 'InterviewDetailView') {
    dataLayer.push({
      page_type: 'interview-detail',
      site_type: 'interview',
    });
  }
});

router.beforeEach(async (to, from, next) => {
  const bodyTag = document.getElementsByTagName('BODY')[0];
  bodyTag.className = to.meta.className;

  const path = to.path;
  const pathSegments = path.split('/').filter((segment) => segment !== '');
  const langParam = pathSegments[0];

  const supportedLanguagesWithoutDefault = supportedLanguages.filter((lang) => lang !== defaultLanguage);
  const isLangSegmentPresentAndValid = pathSegments.length > 0 && supportedLanguagesWithoutDefault.includes(langParam);

  let targetLang = defaultLanguage; // Varsayılan olarak 'en'

  if (path.toLowerCase().startsWith(`/${defaultLanguage}/`)) {
    const newPath = path.substring(defaultLanguage.length + 1) || '/'; // Remove /en prefix, ensure '/' if path was just '/en/'
    return next({
      path: newPath,
      query: to.query,
      hash: to.hash,
      replace: true,
    });
  }

  if (isLangSegmentPresentAndValid) {
    targetLang = langParam;
  } else {
    targetLang = defaultLanguage;
  }

  const targetLocaleCode = localeMap[targetLang] || defaultLocale;
  if (ResourceManager.CurrentLang !== targetLocaleCode) {
    ResourceManager.CurrentLang = targetLocaleCode;
    await ResourceManager.Get().then((res) => {
      store.dispatch('callSetResource', { List: res.List });
      localStorage.setItem('locale', targetLang);
      document.documentElement.lang = targetLocaleCode;
      window.dejavuApp.$moment.locale(targetLang);
    });
  }
  if (localStorage.getItem('locale') !== targetLang) {
    localStorage.setItem('locale', targetLang);
  }

  const isAuth = AccountService.checkAuth();

  const langParamForRedirect = targetLang === defaultLanguage ? undefined : targetLang;

  if (to.name === 'LoginView' || to.name === 'RegisterView' || to.name === 'ForgotPassView' || to.name === 'ResetPasswordView') {
    if (isAuth === true) {
      return next({
        name: 'HomeView',
        params: { ...to.params, lang: langParamForRedirect },
        query: to.query,
        hash: to.hash,
      });
    }
  }

  if (to.meta.requiresAuth === true) {
    if (isAuth === false) {
      return next({
        name: 'LoginView',
        params: { ...to.params, lang: langParamForRedirect },
        query: to.query,
        hash: to.hash,
      });
    }
  }

  window.scrollTo(0, 0);
  next();
});

export default router;
